/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#footer-bar[_ngcontent-%COMP%] {\r\n    width:100px;\r\n    margin:auto;\r\n    padding:5px 0px 5px 10px;\r\n}"];
export { styles as styles };
